import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  AdministrativeRuleHistoryModel,
  StudentAdministrativeRuleModel,
} from '@core/models';
import { PDFViewerTool } from '@progress/kendo-angular-pdfviewer/models/toolbar-tool';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-administrative-norms-viewer',
  templateUrl: './administrative-norms-viewer.component.html',
  styleUrls: ['./administrative-norms-viewer.component.scss'],
})
export class AdministrativeNormsViewerComponent {
  public tools: PDFViewerTool[] = [
    'search',
    'selection',
    'spacer',
    'zoom',
    'zoomInOut',
    'spacer',
    'download',
    'print',
    'pager',
  ];
  public rule: StudentAdministrativeRuleModel | AdministrativeRuleHistoryModel;
  public fromRule: boolean;
  public fileUrl: string;
  public studentName: string;
  public fromAddendum = false;

  public getStudentName(): string {
    let studentName = '';
    if (this.fromAddendum) {
      return this.studentName;
    }
    if ('student' in this.rule) {
      studentName = `${this.rule.student.name}_${this.rule.student.name}`;
    } else if ('studentName' in this.rule) {
      studentName = `${this.rule.studentName}_${this.rule.studentLastName}`;
    }

    return studentName;
  }
}
